(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["custom-row-slider-about-us"] && !window.DesignMode) return;
  try {
    
  $('.custom-row-slider-about-us').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    prevArrow:
      '<button type="button" class="slick-prev" aria-label="' +
      theme.strings.previous +
      '">' +
      theme.icons.chevronLeft +
      '</button>',
    nextArrow:
      '<button type="button" class="slick-next" aria-label="' +
      theme.strings.next +
      '">' +
      theme.icons.chevronRight +
      '</button>',
    //slidesToShow: $('.custom-row-slider').data('desktop-column'),
    slidesToShow: 2,
    centerMode: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          //slidesToShow: $('.custom-row-slider').data('desktop-column'),
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-row-slider"] && !window.DesignMode) return;
  try {
    
  $('.custom-row-slider').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    prevArrow:
      '<button type="button" class="slick-prev" aria-label="' +
      theme.strings.previous +
      '">' +
      theme.icons.chevronLeft +
      '</button>',
    nextArrow:
      '<button type="button" class="slick-next" aria-label="' +
      theme.strings.next +
      '">' +
      theme.icons.chevronRight +
      '</button>',
    slidesToShow: 1.87,
    centerMode: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.17,
          arrows: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");      
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      // console.log("productRecommendationsSection",productRecommendationsSection);
      theme.loadProductGridForm(productRecommendationsSection,"load");
      theme.loadCarousels(productRecommendationsSection);
      window.productgridswatch(productRecommendationsSection);
      $('.product-form', productRecommendationsSection).trigger('load-product-form');
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();      
    }
  };
  request.send();
  
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
    
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();


  } catch(e) { console.error(e); }
})();
      })();
